import PropTypes from 'prop-types';
import './style.scss';

const MapLegendClassItem = ({color, label, unit}) => {
	return (
		<div className="ptr-MapLegendClassItem">
			<div style={{background: color}} />
			<span>
				{label} {unit}
			</span>
		</div>
	);
};

MapLegendClassItem.propTypes = {
	color: PropTypes.string,
	label: PropTypes.string,
	unit: PropTypes.string,
};

export default MapLegendClassItem;
